<template>
  <div class="card">
    <div class="card-header">
      <div class="bolder-title"> Отзывы по тональности</div>

    </div>
    <div class="graph">
      <Bar v-if="datacollection"
           :options="chartOptions"
           :data="datacollection"
      />
    </div>
  </div>

</template>

<script>
import {ReviewApi} from "@/api/reviews";
import {Bar} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement} from 'chart.js'
import datesMixin from "@/mixins/filterDates";
import {handleChartClick} from "@/plugins/chartPlugin";


ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement)
export default {
  name: 'ToneGraphBar',
  components: {Bar},
  data() {
    return {
      datacollection: {
        labels: [],
        datasets: []
      },
      stats: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = chartElement.length ? 'pointer' : 'default';
        },
        onClick: handleChartClick(this.$router, (dataIndex, clickedLabel) => {
          const tone = this.$TONES.find(t => t.name === clickedLabel);
          return tone ? {tones: tone.id} : null;
        }),

        aspectRatio: 1,
        scales: {
          x:
              {
                stacked: true,
                grid: {
                  display: false
                },
                ticks: {
                  autoSkip: false,
                },
              },
          y:
              {
                stacked: true,
                grid: {
                  display: false
                },

              },

        },
        interaction: {
          mode: 'index',
          intersect: false,
        },

        plugins: {
          legend: {
            display: false,
          }
        }
      }

    }
  }
  ,
  mixins: [datesMixin],
  mounted:

      function () {
        this.getData();

      }

  ,
  computed: {}
  ,
  methods: {
    getData() {
      ReviewApi.tone_graph_bar(this.date_from, this.date_to).then(response => {
        this.datacollection = {
          labels: ["Позитивные", "Негативные"],
          datasets: [
            {
              label: "Тональность",
              backgroundColor: [
                this.$TONES[1].color,
                this.$TONES[0].color
              ],
              borderRadius: 5,
              borderColor: [
                this.$TONES[1].bcolor,
                this.$TONES[0].bcolor
              ],
              borderWidth: 2,
              data: [
                response.positives,
                response.negatives
              ]
            }
          ]
        }


      })
    }
  }
}

</script>
<style scoped lang="scss">
.graph {
  height: 250px;
}

</style>

